import { render } from "./MessagePatternPage.vue?vue&type=template&id=865979d8&scoped=true"
import script from "./MessagePatternPage.vue?vue&type=script&lang=js"
export * from "./MessagePatternPage.vue?vue&type=script&lang=js"

import "./MessagePatternPage.vue?vue&type=style&index=0&id=865979d8&scoped=true&lang=css"

import exportComponent from "/Users/amane/Documents/-4°/AmaneStudio/A++/Amane.dev/portfolio.amane.dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-865979d8"]])

export default __exports__